import script from "./HotelView.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelView.vue?vue&type=script&setup=true&lang=js"

import "./HotelView.vue?vue&type=style&index=0&id=ab467f98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab467f98"]])

export default __exports__